import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditGeneralUserComponent } from './components/edit-general-user/edit-general-user.component';
import { EditGeneralUsersComponent } from './components/edit-general-users/edit-general-users.component';
import { GeneralAdminComponent } from './components/general-admin/general-admin.component';
import { EditGeneralUserGroupsComponent } from './components/edit-general-user-groups/edit-general-user-groups.component';
import { EditGeneralUserGroupComponent } from './components/edit-general-user-group/edit-general-user-group.component';
import { EditGeneralCompaniesComponent } from './components/edit-general-companies/edit-general-companies.component';
import { EditGeneralCompanyComponent } from './components/edit-general-company/edit-general-company.component';
import { AdminObjectListComponent } from './components/admin-object-list/admin-object-list.component';
import { AdminObjectEditComponent } from './components/admin-object-edit/admin-object-edit.component';
import { EditGlobalEMailTemplatesComponent } from './components/edit-global-email-templates.component/edit-global-email-templates.component';
import { EditGlobalEMailTemplateComponent } from './components/edit-global-email-template.component/edit-global-email-template.component';
import { AuthenticationService } from './services/authentication.service';

const routes: Routes = [
    {
        path: "admin",
        component: GeneralAdminComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/editGeneralUsers",
        component: EditGeneralUsersComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/editGeneralUser/:id",
        component: EditGeneralUserComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/editGeneralCompanies",
        component: EditGeneralCompaniesComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/editGeneralCompany/:id",
        component: EditGeneralCompanyComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/editGeneralUserGroups",
        component: EditGeneralUserGroupsComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/editGeneralUserGroup/:id",
        component: EditGeneralUserGroupComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/editGlobalEMailTemplates",
        component: EditGlobalEMailTemplatesComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/editGlobalEMailTemplate/:id",
        component: EditGlobalEMailTemplateComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/generic-list/:scope/:id",
        component: AdminObjectListComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/generic-edit/:scope/:id/:key",
        component: AdminObjectEditComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SmBaseRoutingModule2 {
}
